import React from 'react';
import { StringConstantsMixin } from '../mixins/shared/string_constants_mixin';

const createReactClass = require('create-react-class');

const BranchAppText = createReactClass({
  getInitialState() {
    return {
      phoneNumber: '',
      requestPending: false,
      rawErrors: null,
      success: false,
      failedNumbers: []
    };
  },
  componentWillMount() {
    this.branchKey = this.props.branchKey;
  },
  componentDidMount() {
    if (branch) {
      const branchOptions = {
        disable_entry_animation: true,
        disable_exit_animation: true
      };
      branch.init(this.branchKey, branchOptions);
    } else {
      console.error('Branch SDK not present');
    }
  },
  branchApiCallback(errors) {
    this.setState({ requestPending: false });
    if (errors) {
      this.setState({
        rawErrors: errors,
        failedNumbers: this.state.failedNumbers.concat(this.state.phoneNumber)
      });
    } else {
      this.setState({ success: true, rawErrors: null });
    }
  },
  handleSendClick() {
    if (this.clicksShouldWork()) {
      _gaq.push(['_trackEvent', 'Retail', 'Mobile', 'Send Text']);
      this.setState({ requestPending: true });
      branch.sendSMS(this.state.phoneNumber, {}, {}, this.branchApiCallback);
    }
  },
  handleOnChange(e) {
    this.setState({ phoneNumber: e.target.value });
  },
  validate(number) {
    const phoneno = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;
    return !!(number && this.state.phoneNumber.match(phoneno));
  },
  clicksShouldWork() {
    return (
      this.validate(this.state.phoneNumber) &&
      !this.state.requestPending &&
      !this.state.success &&
      this.state.failedNumbers.indexOf(this.state.phoneNumber) == -1
    );
  },
  render() {
    let buttonClass = 'new-btn';
    let validationSpanClasses = 'valid';
    if (!this.clicksShouldWork()) {
      buttonClass += ' disabled';
      validationSpanClasses += ' hidden';
    }
    let buttonText = 'Send link';
    if (this.state.success == true) {
      buttonText = 'Sent';
    }
    let errorSpan = '';
    let textInputDivClasses = 'input string required';
    if (this.state.rawErrors) {
      textInputDivClasses += ' field_with_errors';
      errorSpan = (
        <span className="error">
          There was a problem sending the text.
          <br />
          Please check the number and try again.
        </span>
      );
    }
    return (
      <div className="form-content mid">
        <div className="holder">
          <div className={textInputDivClasses}>
            <input
              type="text"
              className="string required text"
              ref="phoneNumber"
              name="phoneNumber"
              id="phone-box"
              maxLength="12"
              placeholder="555-555-5555"
              value={this.state.phoneNumber}
              onChange={this.handleOnChange}
            />
            <span className={validationSpanClasses} />
            {errorSpan}
          </div>
        </div>
        <div>
          <input className={buttonClass} type="submit" value={buttonText} onClick={this.handleSendClick} />
        </div>
      </div>
    );
  }
});

export { BranchAppText };
